/**
 *
 * This object contains the Glovo Feature Toggles used in the application.
 * They must be written using uppercase.
 * Example: MY_FEATURE_ENABLED
 *
 * Glovo Feature Toggles BackOffice:
 * https://beta-admin.glovoapp.com/toggles
 *
 */
export const featureToggles = {
  FEATURE_FLAG_TEST: false, // delete Jira ticket here
  GLOVO_WEB_OPEN_API_PILOT_ENABLED: false, // https://glovoapp.atlassian.net/browse/WP-4697
  WEBX_REACT_DH_HELP_CENTER_ENABLED: false, // https://glovoapp.atlassian.net/browse/WEBX-714
  WEBX_REACT_PAST_ORDERS_ENABLED: false, // https://glovoapp.atlassian.net/browse/WEBX-749
  PAY_V4_PAYMENT_METHODS_ENABLED: false, // https://glovoapp.atlassian.net/browse/FTP-1562
  CUSTOMER_HELP_CENTER_ENABLED: false, // https://glovoapp.atlassian.net/browse/WEBX-698
  LC_FE_DH_COURIER_CHAT_ENABLED: false, // https://glovoapp.atlassian.net/browse/WEBX-699
  LC_FE_DISABLE_CC_CHAT: false, // https://glovoapp.atlassian.net/browse/WEBX-720
  WEB_PAST_ORDERS_DOWNLOAD_INVOICE: false,
}
